import { BaseModel } from '../../common/base/model';

export class NewBankModel extends BaseModel {
  constructor(data) {
    super(data, {
      portfolioId: null,
      investmentId: null,
      orderOfAccountFields: null,
      blz: null
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/start/bank.model.js